import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
export const ArrowHeadRight = props => {
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("polygon", { points: "10 17 15 12 10 7" })));
};
export default ArrowHeadRight;
